// Header Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import DateUtil from '../../../lib/dateutil.jsx'

class Calendar extends Component {
  constructor (props) {
    super(props)

    this.selectionEnabled = false
    this.animationDirection = 'forward'
    this.currentDate = DateUtil.getUTCCurrentDate()
    this.highlightInfo = this._getHighlightedDates(
      this.props.highlightedPeriods
    )
    this._references = {
      calendar: React.createRef()
    }
  }

  static get propTypes () {
    return {
      date: PropTypes.number,
      indexStart: PropTypes.number,
      indexEnd: PropTypes.number,
      startDate: PropTypes.any,
      endDate: PropTypes.any,
      highlightedPeriods: PropTypes.array,
      setRange: PropTypes.func,
      onSelect: PropTypes.func,
      disabledPeriods: PropTypes.any,
      isSingleDate: PropTypes.bool,
      onSelectSingleDate: PropTypes.func,
      onError: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      date: 0,
      indexStart: 0,
      indexEnd: 0,
      startDate: null,
      endDate: null,
      highlightedPeriods: [],
      setRange: null,
      onSelect: null,
      disabledPeriods: [],
      isSingleDate: false,
      onSelectSingleDate: null,
      onError: null
    }
  }

  setSelectionEnabled (bSelectionEnabled) {
    this.selectionEnabled = bSelectionEnabled
  }

  handleClick (index) {
    const { setRange, indexStart, indexEnd } = this.props
    const bUpdateRange = this._validateSelectedDate(
      index,
      indexStart,
      this.props.disabledPeriods
    )
    if (bUpdateRange) {
      if (this.props.isSingleDate) {
        if (this.props.onSelectSingleDate) {
          this.props.setRange(index)
          this.props.onSelectSingleDate(index)
        }
      } else {
        if (this.selectionEnabled) {
          if (index === indexStart) {
            this.selectionEnabled = false
            setRange(index)
          } else {
            this.selectionEnabled = false
            setRange(this.props.indexStart, index)
          }
        } else {
          if (index === indexEnd) {
            this.selectionEnabled = true
          } else {
            this.selectionEnabled = true
            setRange(index)
          }
        }

        if (this.props.onSelect) {
          this.props.onSelect(this.selectionEnabled)
        }
      }
    }
  }

  mouseOver (index) {
    if (this.selectionEnabled) {
      this.props.setRange(this.props.indexStart, index)
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate (nextProps) {
    if (nextProps.date !== this.props.date) {
      this.animationDirection =
        nextProps.date - this.props.date > 0 ? 'forward' : 'backward'
    }

    if (
      nextProps.highlightedPeriods &&
      nextProps.highlightedPeriods !== this.props.highlightedPeriods
    ) {
      this.highlightInfo = this._getHighlightedDates(
        nextProps.highlightedPeriods
      )
    }
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.date !== this.props.date &&
      this._references.calendar.current
    ) {
      this._references.calendar.current.classList.add(
        `animate--${this.animationDirection}`
      )
    }
  }

  getDay (date, key, month, highlightInfo) {
    const time = date.getTime()
    const currentDate = this.currentDate
    const { indexEnd, indexStart, startDate, endDate } = this.props
    const dateDay = date.getDate()
    const dateMonth = date.getMonth()
    const dateYear = date.getFullYear()
    const startDateDay = startDate ? startDate.getDate() : null
    const startDateMonth = startDate ? startDate.getMonth() : null
    const startDateYear = startDate ? startDate.getFullYear() : null
    const endDateDay = endDate ? endDate.getDate() : null
    const endDateMonth = endDate ? endDate.getMonth() : null
    const endDateYear = endDate ? endDate.getFullYear() : null

    let dayClass = time > indexStart && time < indexEnd ? 'selected' : ''
    if (
      dateDay === startDateDay &&
      dateMonth === startDateMonth &&
      dateYear === startDateYear &&
      indexEnd > indexStart
    ) {
      dayClass = ' sel--start'
    } else if (time === indexStart && indexEnd > indexStart) {
      dayClass += ' sel--start'
    } else if (
      dateDay === startDateDay &&
      dateMonth === startDateMonth &&
      dateYear === startDateYear &&
      !indexEnd
    ) {
      dayClass += ' sel--oneday'
    }

    if (
      dateDay === endDateDay &&
      dateMonth === endDateMonth &&
      dateYear === endDateYear &&
      indexEnd > indexStart
    ) {
      dayClass = ' sel--end'
    } else if (time === indexEnd && time > indexStart) {
      dayClass += ' sel--end'
    }

    if (
      startDateDay === endDateDay &&
      startDateMonth === endDateMonth &&
      startDateYear === endDateYear &&
      startDateDay === dateDay &&
      startDateMonth === dateMonth &&
      startDateYear === dateYear
    ) {
      dayClass = ' sel--oneday'
    }

    if (
      !dayClass &&
      dateDay === currentDate.getDate() &&
      dateMonth === currentDate.getMonth() &&
      dateYear === currentDate.getFullYear()
    ) {
      dayClass += ' sel--today'
    }

    const hInfo = highlightInfo[DateUtil.getDisplayDate(date)]
    if (hInfo && hInfo.className) {
      dayClass += ` ${hInfo.className}`
    }

    dayClass += date < currentDate.setHours(0) ? ' out--range' : ''
    dayClass +=
      date.getMonth() === month ? ' calendar__day' : ' calendar__day dis'

    return (
      <td
        className={dayClass}
        onClick={this.handleClick.bind(this, time)}
        onMouseOver={this.mouseOver.bind(this, time)}
        key={key}
      >
        <div className='calendar__inner-day'>{date.getDate()}</div>
      </td>
    )
  }

  render () {
    const date = new Date(this.props.date)
    const month = date.getMonth()

    date.setDate(1)
    if (this.animationDirection === 'forward') {
      date.setMonth(date.getMonth() - 1)
    }

    const firstDay = date.getDay()
    if (firstDay !== 1) {
      firstDay === 0
        ? date.setDate(date.getDate() - 6)
        : date.setDate(date.getDate() - (firstDay - 1))
    }
    date.setDate(date.getDate() - 1)
    const highlightInfo = this.highlightInfo

    return (
      <div className='calendar__wrap'>
        <table
          className='calendar__table'
          ref={this._references.calendar}
          key={this.props.date}
          cellSpacing='0'
        >
          <tbody>
            {Array(12)
              .fill(0)
              .map((i, key) => {
                return (
                  <tr key={key}>
                    {Array(7)
                      .fill(0)
                      .map((_i, _key) => {
                        date.setDate(date.getDate() + 1)
                        return this.getDay(date, _key, month, highlightInfo)
                      })}
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    )
  }

  _getHighlightedDates (periods) {
    const highlightInfo = {}

    periods.map(period => {
      if (period.from && period.to) {
        const fromDate = new Date(period.from)
        const toDate = new Date(period.to)

        if (DateUtil.isDateEqual(fromDate, toDate)) {
          // Hightlight start date
          highlightInfo[DateUtil.getDisplayDate(fromDate)] = {
            className: 'highlight--oneday'
          }
        } else {
          // Hightlight start date
          highlightInfo[DateUtil.getDisplayDate(fromDate)] = {
            className: 'highlight--start'
          }

          // Hightlight middle dates
          if (fromDate.getTime() < toDate.getTime()) {
            let tempDate = DateUtil.addDaysToDate(fromDate, 1)
            while (tempDate.getTime() < toDate.getTime()) {
              highlightInfo[DateUtil.getDisplayDate(tempDate)] = {
                className: 'highlighted'
              }

              tempDate = DateUtil.addDaysToDate(tempDate, 1)
            }
          }

          // Hightlight end date
          highlightInfo[DateUtil.getDisplayDate(toDate)] = {
            className: 'highlight--end'
          }
        }
      } else if (period.from) {
        const fromDate = new Date(period.from)
        highlightInfo[DateUtil.getDisplayDate(fromDate)] = {
          className: 'highlight--oneday'
        }
      }
    })

    return highlightInfo
  }

  _validateSelectedDate (selDate, startDateTS, disabledPeriods) {
    let bValid = true
    if (selDate && disabledPeriods && disabledPeriods.length > 0) {
      this.highlightInfo = this._getHighlightedDates(
        this.props.highlightedPeriods
      )

      disabledPeriods.forEach(period => {
        const selDateTS = new Date(selDate).getTime()
        if (period.from && period.to) {
          const fromTS = new Date(period.from).getTime()
          const toTS = new Date(period.to).setHours(23, 59, 59, 0)
          if (selDateTS >= fromTS && selDateTS <= toTS) {
            bValid = false
          } else if (
            startDateTS &&
            startDateTS <= fromTS &&
            selDateTS >= toTS
          ) {
            bValid = false
          }
        }
      })

      if (!bValid) {
        const hInfo = this.highlightInfo[DateUtil.getDisplayDate(selDate)]
        if (hInfo) {
          hInfo.className += ' highlight--error'
        } else {
          this.highlightInfo[DateUtil.getDisplayDate(selDate)] = {
            className: 'highlight--error'
          }
        }

        this.selectionEnabled = false
        this.props.setRange(0, 0)

        if (this.props.onError) {
          this.props.onError()
        }

        this.setState({ dataDate: new Date() })
      }
    }

    return bValid
  }
}

export default Calendar
